// Import all resources directly
import OrderResource from 'App/resources/Order';

const resourceMap: Record<string, any> = {
	Order: OrderResource
};

export const getResourceInstance = (resourceName: string) => {
	const resourceInstance = resourceMap[resourceName];
	if (!resourceInstance) {
		throw new Error(`Resource '${resourceName}' not found in mapping`);
	}

	return resourceInstance;
};

export const getAvailableResourceNames = () => {
	return Object.keys(resourceMap);
};
